import {
  addSupplier,
  delSuppliers,
  editSupplier,
  getSupplierDetail,
  getSupplierList,
  getSuppliertypeList
} from '../../services/supplierapi'

export default {
  state: {
    selectsupplierid: 0,
    suppliertyleList: [],
  },
  mutations: {
    setSelectSupplierId (state, supplierId) {
      state.selectsupplierid = supplierId
    },
    setSupplierTypeList (state, suppliertyleList) {
      state.suppliertyleList = suppliertyleList
    }
  },
  actions: {
    getSupplierList (store, params) {
      return getSupplierList(params)
    },
    addSupplier (store, params) {
      return addSupplier(params)
    },
    editSupplier (store, {supplierId, params}) {
      return editSupplier(supplierId, params)
    },
    getSupplierDetail (store, supplierId) {
      return getSupplierDetail(supplierId)
    },
    delSuppliers (store, supplierIdList) {
      return delSuppliers(supplierIdList)
    },
    handleSelectSupplierId ({commit}, supplierId) {
      commit('setSelectSupplierId', supplierId)
    },
    getSuppliertypeList ({commit}) {
      return getSuppliertypeList().then(res => {
        commit('setSupplierTypeList', res.data)
      })
    }
  }
}
